import { combineReducers } from 'redux';
import {
  RouterVisualizerReducer,
  IRouterVisualizerAppState,
} from 'plugin-router-visualizer';

// Please add your "combined Reducers" here
export const rootReducer = combineReducers<IRouterVisualizerAppState>({
  ...RouterVisualizerReducer,
});

// If you are using redux-persist and want to store data into session storage,
// you can add any whitelist states you want to persist here
export const whiteList = ['biitInstances', 'updatedTimestamp'];
